import { parseTiptapDocument, type RichContentDocument } from "@forento/rich-content"
import { type RichContentValue } from "@forento/ui/components/RichContentEditor"

export type { RichContentValue }

export function loadRichContent(value: string | null): RichContentValue | null {
	const document = parseTiptapDocument(value)
	return document === null ? null : { isModified: false, isEmpty: false, value: document }
}

export function parseRichContent(value: string | null): RichContentDocument | null {
	return parseTiptapDocument(value)
}

export function exportRichContent(value: RichContentValue | null): string | null {
	if (value === null || value.isEmpty) return null
	return JSON.stringify(value.value)
}

export function exportEditedRichContent(value: RichContentValue | null): string | null | undefined {
	if (value === null || value.isEmpty) return null
	if (!value.isModified) return undefined
	return JSON.stringify(value.value)
}
